export const overviewIncludeKey = Symbol('overviewInclude')

// Dialog includes use their surrounding content area's scrollbar.
export function useOverviewAutoGrow(requested) {
  const included = inject(overviewIncludeKey, false)
  return computed(() => Boolean(requested() && !included))
}
